import React from 'react';

import { getProductFromContext } from '../../../../context/product';
import { getProductType, parseMetafields, isApparelProduct } from '../../../../utils/product';
import ApparelSpecs from './ApparelSpecs';
import CollectibleSpecs from './CollectibleSpecs';

const SpecsToggle: React.FC = () => {
  const product = getProductFromContext();
  const metafields = parseMetafields(product.metafields);
  const productType = getProductType(product.productType);

  if (isApparelProduct(product)) {
    return <ApparelSpecs productType={productType} disclaimer={metafields.disclaimer} product={product} />;
  }

  return <CollectibleSpecs productType={productType} metafields={metafields} product={product} />;
};

export default SpecsToggle;
